<template>
	<!-- add 'single_item' to addedClass for the single element -->
	<div :class="['item_sidebar input_number_block', addedClass]">
		<div class="wrapper_title wrapper_body mb_0">
			<div class="title" v-if="title !== 'withoutTitle'">{{ title }}</div>
			<input-field type="number" small :value.number="value.number" :append="value.append||'px'" :placeholder="value.placeholder"
			             @input="inputDataUpdate($event)" :min="0" :max="10000"/>
		</div>
	</div>
</template>

<script>
import InputField from '@/components/base/input-field';

export default {
	name: 'InputNumber',
	props: ['value', 'title', 'addedClass'],
	components: {InputField},
	data: function () {
		return {
			numberValue: {
				append: 'px',
				number: 0,
				min: 0,
				max: 9999
			},
		}
	},
	methods: {
		inputDataUpdate(val) {
			if (val) {
				this.numberValue.number = +val;
			}
			if (this.addedClass !== 'single_item') {
				this.$emit('updated', this.numberValue);
			} else {
				this.$emit('inputNumberUpdate', this.numberValue);
			}
		},
	},
	created() {
		this.numberValue = JSON.parse(JSON.stringify(this.value));

		// FIXME: WTH is this?
		if ((this.title == 'Hours') || (this.title == 'Minutes') || (this.title == 'Seconds')) {
			this.inputDataUpdate();
		}
	}
}
</script>
<style lang="scss" scoped>
.input_number_block {
	.input-field {
		max-width: 150px;
	}
}
</style>
